export * from './seller-bank-data.component';
